// extracted by mini-css-extract-plugin
export default {"uploadInput":"styles_uploadInput__Xj-vK","ButtonText":"styles_ButtonText__+XCUC","uploadText":"styles_uploadText__nhD9R","uploadIcon":"styles_uploadIcon__BAC0L"};